<template>
	<div>
	<c-dialog ref="dialog" mode="slide" width="50vw" mask-close>
		<template #head>
			<div v-if="afterSale.after_sale_no" class="m-detail-tag flex-center-cross">
				<label>{{afterSale.after_sale_no}}</label>
				<c-state tag async dict="SALE_AFTER_SALE_STATE" :value="afterSale.after_sale_state"></c-state>
			</div>
		</template>

		<c-title >基础信息</c-title>
		<!-- 产品信息详情 -->
		<c-detail class="m-detail-table" column="2">
			<c-detail-item label="订单号">{{afterSale.order_no || '-'}}</c-detail-item>
			<c-detail-item label="三方订单号">{{afterSale.third_party_order_no || afterSale.order_no || '-'}}</c-detail-item>
			<c-detail-item v-if="afterSale.order_type == 2" label="销售渠道">
				{{afterSale.channel_name || '-'}}
			</c-detail-item>
			<c-detail-item label="售出价">{{formatPrice(product.sale_price)}}</c-detail-item>
			<c-detail-item label="售后类型">
				<c-state async dict="SALE_AFTER_SALE_TYPE" :value="afterSale.after_sale_type"></c-state>
			</c-detail-item>
			<c-detail-item label="退款金额">
				<span class="m-amount">{{formatPrice(afterSale.after_sale_amount)}}</span>
			</c-detail-item>
			<c-detail-item label="退款信息">
				<span v-if="!Number(afterSale.refund_amount)">-</span>
				<div v-else class="m-product-info">
					<p class="m-amount">{{formatPrice(afterSale.refund_amount)}}</p>
					<p class="m-product-info-code">{{afterSale.refund_date || '-'}}</p>
				</div>
			</c-detail-item>
            <c-detail-item label="创建时间" >{{afterSale.create_date || '-'}}</c-detail-item>
            <c-detail-item label="售后原因" colspan="2">{{afterSale.refund_reason || '-'}}</c-detail-item>
			<c-detail-item label="售后图片" colspan="2">
                <c-file-list v-if="afterSale.after_image_list" :value="afterSale.after_image_list"></c-file-list>
                <span v-else>-</span>
            </c-detail-item>
		</c-detail>

		<!-- 产品信息详情 -->
		<c-title >产品信息</c-title>
		<!-- 产品名称标题 -->
		<h3 class="m-product-title">{{getProductFullName()}}</h3>
		<c-detail class="m-detail-table" column="2">
			<c-detail-item label="类目">{{product.category_name || '-'}}</c-detail-item>
			<c-detail-item label="品牌/型号">{{getBrandModelText()}}</c-detail-item>
			<c-detail-item label="等级">{{product.level_name || '-'}}</c-detail-item>
			<c-detail-item label="背贴码">{{product.produce_code || '-'}}</c-detail-item>
			<c-detail-item label="内存">{{product.memory_name || '-'}}</c-detail-item>
			<c-detail-item label="IMEI">{{product.imei || '-'}}</c-detail-item>
			<c-detail-item label="颜色">{{product.color_name || '-'}}</c-detail-item>
		</c-detail>

		<template v-if="afterSale.order_type == 2 && afterSale.after_sale_type ==1 && afterSale.after_sale_state >1 && afterSale.after_sale_state < 6">
			<c-title>退货信息</c-title>
			<c-detail class="m-detail-table" column="2">
				<c-detail-item label="退货地址" colspan="2">{{afterSale.return_full_name || ''}} {{afterSale.return_phone || ''}} {{afterSale.return_address || '-'}}</c-detail-item>
				<c-detail-item label="退货快递">{{afterSale.return_express_company || '-'}} {{afterSale.return_express_no || '-'}}</c-detail-item>
                <c-detail-item label="退货时间">{{afterSale.return_express_update_date || '-'}}</c-detail-item>
                <c-detail-item v-if="afterSale.after_sale_state == 4 || afterSale.after_sale_state == 5" label="确认收货人">{{afterSale.confirm_receive_user_realname || '-'}}</c-detail-item>
                <c-detail-item v-if="afterSale.after_sale_state == 4 || afterSale.after_sale_state == 5"label="确认收货时间">{{afterSale.confirm_receive_date || '-'}}</c-detail-item>
			</c-detail>
		</template>
		<template v-if="afterSale.after_sale_state ==2 || afterSale.after_sale_state == 5 || afterSale.after_sale_state == 6 ">
			<c-title>审批信息</c-title>
			<c-detail class="m-detail-table" column="2">
				<c-detail-item label="审批人">{{afterSale.audit_user_realname || '-'}}</c-detail-item>
				<c-detail-item label="审批时间">{{afterSale.audit_date || '-'}}</c-detail-item>
				<c-detail-item v-if="afterSale.after_sale_state == 6" label="驳回原因">{{afterSale.audit_remark || '-'}}</c-detail-item>
                <c-detail-item v-if="afterSale.after_sale_state == 5" label="退款人">{{afterSale.refund_user_realname || '-'}}</c-detail-item>
                <c-detail-item v-if="afterSale.after_sale_state == 5" label="退款时间">{{afterSale.refund_date || '-'}}</c-detail-item>
			</c-detail>
		</template>

        <template #button>
            <!--按钮可见性以服务端下发的 buttons 为准（与写接口同口径）：同意申请=自营退货退款待审核(audit)/自营仅退款待审核(refund)；驳回=自营/三方待审核、自营待商家退款-->
            <!--refund 位在自营退货退款待商家退款(4) 也为 visible，此处必须靠 after_sale_state==1 兜住，不得照列表口径删掉该裸状态门-->
            <c-button v-if="auth('b_online_aftersales_order_audit') && afterSale.after_sale_state == 1 && (afterSale.buttons?.audit?.visible || afterSale.buttons?.refund?.visible)" size="dialog" color="main" @click="handleOnlineAudit">同意申请</c-button>
            <c-button v-if="auth('b_online_aftersales_order_audit') && afterSale.buttons?.reject?.visible" size="dialog" color="red" @click="handleOnlineReject">驳回申请</c-button>
            <c-button size="dialog" @click="$refs.dialog.close()">关闭</c-button>
            <!--无同意申请按钮时（如待商家退款只能驳回），补一个关闭钮避免抽屉无退出入口-->
<!--            <c-button v-if="!(auth('b_online_aftersales_order_audit') && afterSale.buttons?.audit?.visible)" size="dialog" @click="$refs.dialog.close()">关闭</c-button>-->
        </template>
	</c-dialog>

	<!-- 驳回申请弹窗 -->
	<c-dialog ref="rejectDialog" title="驳回申请" width="480">
		<div class="m-reject-box">
			<label class="m-label"><span class="m-required">*</span> 驳回原因</label>
			<c-input v-model="auditRemark" type="textarea" rows="4" placeholder="请输入驳回原因" maxlength="200"></c-input>
		</div>

		<template #button>
			<c-button size="dialog" color="red" @click="submitReject">确认驳回</c-button>
			<c-button size="dialog" @click="$refs.rejectDialog.close()">取消</c-button>
		</template>
	</c-dialog>

	<!-- 同意申请--退货退款（选择退货地址） -->
	<c-dialog ref="returnAddressDialog" title="同意申请-退货退款" width="520">
		<div class="m-return-address-box">
			<label class="m-label"><span class="m-required">*</span> 请选择退货地址</label>
			<div class="m-return-address-list">
				<div
					v-for="item in addressList"
					:key="item.id"
					:class="['m-return-address-item', {'m-active': selectedAddressId == item.id}]"
					@click="selectedAddressId = item.id"
				>
					<i class="m-radio"></i>
					<span class="m-return-address-text">
						<span class="m-return-address-contact">{{item.name}}【{{item.phone}}】</span>
						<span class="m-return-address-addr">{{item.full_address}}</span>
					</span>
				</div>
				<div v-if="!addressList.length" class="m-return-address-empty">请先在地址管理中添加售后退货地址</div>
			</div>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="submitReturnAddress">确认同意</c-button>
			<c-button size="dialog" @click="$refs.returnAddressDialog.close()">取消</c-button>
		</template>
	</c-dialog>

	<!-- 同意申请--仅退款【补差】（退款金额） -->
	<c-dialog ref="refundAmountDialog" title="同意申请-仅退款" width="520">
		<div class="m-refund-amount-box">
			<label class="m-label"><span class="m-required">*</span> 退款金额</label>
			<div class="m-refund-amount-input">
				<c-input v-model="refundAmount" placeholder="请输入退款金额"></c-input>
				<span class="m-unit">元</span>
			</div>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="submitRefundAmount">确认同意</c-button>
			<c-button size="dialog" @click="$refs.refundAmountDialog.close()">取消</c-button>
		</template>
	</c-dialog>
	</div>
</template>

<script>
	export default {
		name: 'onlineAftersaleDetail',

		data() {
			return {
				afterSaleId: '',
				productId: '',
				afterSale: {},
				product: {},
				auditRemark: '',
				addressList: [],
				selectedAddressId: '',
				refundAmount: ''
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.afterSaleId = data.afterSaleId;
				this.productId = data.productId;
				this.afterSale = {};
				this.product = {};
				this.$refs.dialog.open({title: '线上售后详情'});
				this.loadDetail();
			},

			/*********加载售后商品详情**********/
			loadDetail() {
				this.request({
					url: '/aftersale/product_detail',
					data: {
						id: this.afterSaleId,
						after_sale_product_id: this.productId
					},
					loading: true,
					success: data => {
						this.afterSale = data.order_info || {};
						this.product = data.product_info || {};
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取完整产品名称**********/
			getProductFullName() {
				var p = this.product;
				var parts = [];
				if (p.brand_name) parts.push(p.brand_name);
				if (p.model_name) parts.push(p.model_name);
				if (p.color_name) parts.push(p.color_name);
				if (p.memory_name) parts.push(p.memory_name);
				return parts.join(' ') || this.afterSale.product_name || '-';
			},

			/*********获取品牌/型号文本**********/
			getBrandModelText() {
				var p = this.product;
				var parts = [];
				if (p.brand_name) parts.push(p.brand_name);
				if (p.model_name) parts.push(p.model_name);
				return parts.join(' / ') || '-';
			},

			/*********提交驳回（驳回原因必填）**********/
			submitReject() {
				if (!this.auditRemark.trim()) {
					this.$message({message: '请输入驳回原因', type: 'warn'});
					return;
				}
                this.request({
                    url: '/aftersale/reject_online',
                    data: {id: this.afterSaleId, audit_remark: this.auditRemark},
                    loading: true,
                    success: (data, msg) => {
                        this.$message({message: msg || '驳回成功', type: 'success'});
                        this.$refs['rejectDialog'].close();
                        this.$refs.dialog.close();
                        this.$emit('resolve');
                    }
                });
			},

			/*********线上同意申请退货退款选地址/仅退款填金额）**********/
			handleOnlineAudit() {
				if (this.afterSale.after_sale_type == 1) {
					this.selectedAddressId = '';
					this.$refs.returnAddressDialog.open();
					this.loadReturnAddressList();
				} else {
					this.refundAmount = this.afterSale.after_sale_amount || '';
					this.$refs.refundAmountDialog.open();
				}
			},

            /*********线上驳回**********/
            handleOnlineReject() {
                this.$refs.rejectDialog.open();
            },

			/*********加载退货地址列表**********/
			loadReturnAddressList() {
				this.request({
					url: '/sys_saas/address/list/noPage',
                    data: {
                        address_type: 2,
                        is_enable: 1
					},
					success: data => {
						this.addressList = data || [];
						if (!this.selectedAddressId) {
							var defaultAddress = this.addressList.find(item => item.is_default == 1) || this.addressList[0];
							if (defaultAddress) {
								this.selectedAddressId = defaultAddress.id;
							}
						}
					}
				});
			},

			/*********确认同意（退货退款，提交所选退货地址）**********/
			submitReturnAddress() {
				var address = this.addressList.find(item => item.id == this.selectedAddressId);
				if (!address) {
					this.$message({message: '请选择退货地址', type: 'warn'});
					return;
				}
				this.submitAudit(2, '', {
					return_address_id: address.id,
					return_full_name: address.name,
					return_phone: address.phone,
					return_address: address.full_address
				}, 'returnAddressDialog');
			},

			/*********确认同意（仅退款，提交退款金额）**********/
			submitRefundAmount() {
				var amount = parseFloat(this.refundAmount);
				if (isNaN(amount) || amount <= 0) {
					this.$message({message: '请输入正确的退款金额', type: 'warn'});
					return;
				}
                this.request({
                    url: '/aftersale/refund_online',
                    data: {id: this.afterSaleId, refund_amount: amount},
                    loading: true,
                    success: (data, msg) => {
                        this.$message({message: msg || '审批通过', type: 'success'});
                        this.$refs['refundAmountDialog'].close();
                        this.$refs.dialog.close();
                        this.$emit('resolve');
                    }
                });
			},

			/*********提交审核结果（auditResult：审核结果，auditRemark：审核备注，extraData：附加字段如退货地址，closeRef：成功后关闭的弹框ref）**********/
			submitAudit(auditResult, auditRemark, extraData, closeRef) {
				var data = {
					id: this.afterSaleId
				};
				if (extraData) {
					Object.assign(data, extraData);
				}
				this.request({
					url: '/aftersale/audit_online',
					data: data,
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '审批通过', type: 'success'});
						if (closeRef) {
							this.$refs[closeRef].close();
						}
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-after-sale-detail {
		padding: 20px 30px;
	}

	.m-product-title {
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		margin: 0 0 20px 0;
		color: #333;
	}

	// 详情表格样式微调（c-detail默认带边框表格外观）
	.m-detail-table {
		::v-deep .c-detail-item-label {
			background-color: #fafafa;
			color: #666;
			text-align: right;
		}

		.m-amount {
			color: #e53e3e;
			font-weight: bold;
		}
	}

	.m-button-group {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.m-detail-tag {
		gap: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	.m-reject-box {
		padding: 10px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}

		::v-deep textarea {
			min-height: 100px;
			line-height: 1.5;
		}
	}

	.m-return-address-box,
	.m-refund-amount-box {
		padding: 20px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}

	.m-return-address-list {
		min-height: 150px;
		max-height: 320px;
		overflow-y: auto;

		.m-return-address-item {
			display: flex;
			align-items: flex-start;
			gap: 8px;
			padding: 10px 12px;
			margin-bottom: 10px;
			border: 1px solid #e8e8e8;
			border-radius: 4px;
			cursor: pointer;
			font-size: 13px;
			color: #333;
			transition: all 0.2s;

			&:last-child {
				margin-bottom: 0;
			}

			&:hover {
				border-color: #3D5EFF;
			}

			.m-radio {
				flex-shrink: 0;
				width: 14px;
				height: 14px;
				margin-top: 3px;
				border-radius: 50%;
				border: 1px solid #ccc;
				position: relative;
			}

			.m-return-address-text {
				flex: 1;
				min-width: 0;
				line-height: 1.5;
				word-break: break-all;
				.m-return-address-contact,
				.m-return-address-addr {
					display: block;
				}
			}

			&.m-active {
				border-color: #3D5EFF;
				background: #f5f7ff;

				.m-radio {
					border-color: #3D5EFF;

					&::after {
						content: '';
						position: absolute;
						left: 50%;
						top: 50%;
						width: 6px;
						height: 6px;
						border-radius: 50%;
						background: #3D5EFF;
						transform: translate(-50%, -50%);
					}
				}
			}
		}

		.m-return-address-empty {
			text-align: center;
			color: #999;
			padding: 30px 0;
			font-size: 13px;
		}
	}

	.m-refund-amount-input {
		display: flex;
		align-items: stretch;

		.m-unit {
			display: flex;
			align-items: center;
			padding: 0 12px;
			border: 1px solid #dcdfe6;
			border-left: none;
			background: #f5f7fa;
			color: #666;
			font-size: 13px;
		}
	}
</style>
